import './front.scss';
import { HeroMainFront } from './HeroMainFront.js';

new HeroMainFront( document ).init();
